module.exports = __webpack_public_path__ + "static/media/close-blue.1bc36a6b.svg";